// extracted by mini-css-extract-plugin
module.exports = {"miniModal":"MiniModal_miniModal__DCqrP","miniModalContent":"MiniModal_miniModalContent__1ftlP","active":"MiniModal_active__1b9kr"};